(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/normalize-win-retail.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/normalize-win-retail.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _svs$bubble_win_messa = svs.bubble_win_message.extraIcon,
  WIN_ONE_TICKET = _svs$bubble_win_messa.WIN_ONE_TICKET,
  MONTH_WIN_TRISS = _svs$bubble_win_messa.KLOVER_ICON_LEIA,
  TV_WIN = _svs$bubble_win_messa.TV_ICON_LEIA,
  WEEK_WIN = _svs$bubble_win_messa.WEEK_ICON_LEIA,
  WEEK_WIN_50000X6 = _svs$bubble_win_messa.WEEK_50000X6_ICON_LEIA,
  WEEK_WIN_40000X5 = _svs$bubble_win_messa.WEEK_40000X5_ICON_LEIA,
  MONTH_WIN_40000X12 = _svs$bubble_win_messa.MONTH_WIN_40000X12_ICON_LEIA,
  UNKNOWN_HIGH_WIN = _svs$bubble_win_messa.UNKNOWN_HIGH_WIN;

const HIGH_WIN_NO_PAYOUT = 'HIGH_WIN_NO_PAYOUT';
const WIN_FREE_TICKET = 'WIN_FREE_TICKET';
const WIN = 'WIN';
const NO_WIN = 'NO_WIN';
const WIN_NON_FIXED_PRIZE = 'WIN_NON_FIXED_PRIZE';
const MERCHANDISE = 'MERCHANDISE';
const UNDEFINED = 'UNDEFINED';
const prizeDescriptionMap = {
  [WIN_ONE_TICKET]: ['Free Ticket (30)', 'WIN_FREE_TICKET', 'WIN_ONE_TICKET', 'Ny lott a 30 kr'],
  [MONTH_WIN_TRISS]: ['(2 765 000x1) KLOVER', '(2 765 000) KLOVER', 'MONTH_WIN_TRISS'],
  [TV_WIN]: ['(265 000x1) TV-Triss', '(265 000) TV-TRISS', 'TV_WIN_TRISS'],
  [WEEK_WIN]: ['VECKOVINST 15.000 /v i 1 ar', 'WEEK_WIN_15000X52'],
  [WEEK_WIN_50000X6]: ['(300 000) 50.000/v. i 6 veckor', 'WEEK_WIN_50000X6'],
  [WEEK_WIN_40000X5]: ['(200 000) 40.000/v. i 5 veckor', 'WEEK_WIN_40000X5'],
  [MONTH_WIN_40000X12]: ['(480 000) 40.000/man. i 1 ar', 'MONTH_WIN_40000X12']
};
const prizeDescriptionWordsMatch = {
  [MONTH_WIN_TRISS]: ['KLOVER', 'KLÖVER', 'MONTH_WIN_TRISS'],
  [TV_WIN]: ['TV', 'TV-TRISS', 'TV_WIN_TRISS'],
  [MONTH_WIN_40000X12]: ['MONTH_WIN_40000X12']
};
const normalizeWinRetailConstants = {
  HIGH_WIN_NO_PAYOUT,
  WIN_FREE_TICKET,
  WIN,
  NO_WIN,
  winTypes: {
    WIN_NON_FIXED_PRIZE,
    MERCHANDISE,
    UNDEFINED
  },
  winMessage: {
    [WIN_ONE_TICKET]: 'Trisslott värd 30 kr',
    [MONTH_WIN_TRISS]: 'Klöver',
    [TV_WIN]: 'TV',
    [WEEK_WIN]: 'Veckovinst',
    [WEEK_WIN_50000X6]: 'Veckovinst',
    [MONTH_WIN_40000X12]: 'Månadsvinst',
    SPECIAL_WIN: 'Specialvinst'
  }
};
const SPECIAL_WINS = [HIGH_WIN_NO_PAYOUT, WIN_FREE_TICKET];
setGlobal('svs.ticketUtility.utils.normalizeWinRetailConstants', normalizeWinRetailConstants);
setGlobal('svs.ticketUtility.utils.normalizeWinRetail', res => {
  const winAmount = res.winAmount,
    result = res.result,
    winType = res.winType,
    prizeDescription = res.prizeDescription;
  let extraicon = null;
  const amount = parseInt(winAmount, 10);
  let winMessage = "".concat(svs.utils.format.Currency(amount), " kr");
  const winFlag = amount > 0;
  if (SPECIAL_WINS.includes(result)) {
    const prizeDescTrimmed = (prizeDescription || '').trim();
    for (const _ref of Object.entries(prizeDescriptionMap)) {
      var _ref2 = _slicedToArray(_ref, 2);
      const key = _ref2[0];
      const value = _ref2[1];
      if (value.includes(prizeDescTrimmed)) {
        extraicon = key;
        winMessage = normalizeWinRetailConstants.winMessage[key];
        break;
      }
    }
    if (!extraicon) {
      for (const _ref3 of Object.entries(prizeDescriptionWordsMatch)) {
        var _ref4 = _slicedToArray(_ref3, 2);
        const key = _ref4[0];
        const value = _ref4[1];
        const prizeDesc = prizeDescTrimmed.toUpperCase();
        const wordMatch = value.find(v => prizeDesc.includes(v));
        if (wordMatch) {
          extraicon = key;
          winMessage = normalizeWinRetailConstants.winMessage[key];
          svs.ticketgames.ticketUtility.logger.info("Found word match ('".concat(wordMatch, "') in prizeDescription ('").concat(prizeDescription, "') ").concat(JSON.stringify({
            prizeDescription,
            result,
            extraicon,
            winMessage
          })));
          break;
        }
      }
    }
    if (!extraicon) {
      extraicon = UNKNOWN_HIGH_WIN;
      winMessage = normalizeWinRetailConstants.winMessage.SPECIAL_WIN;
      svs.ticketgames.ticketUtility.logger.warn("No applicable extra icon found for object ".concat(JSON.stringify({
        winAmount,
        result,
        winType,
        prizeDescription
      })));
    }
  }
  return {
    extraicon,
    amount,
    winFlag,
    winMessage
  };
});

 })(window);